import axios from 'axios'
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react'
import { constants } from '../Constants'

// Crear el contexto
export const NotificationsContext = createContext()

// Hook personalizado para acceder al contexto de notificaciones
export const useNotificationsContext = () => useContext(NotificationsContext)

export const NotificationsProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]) // sin leer
  const [readNotifications, setReadNotifications] = useState([]) // leídas
  const [unreadCount, setUnreadCount] = useState(0)

  const getUser = () => {
    try {
      return JSON.parse(localStorage.getItem('user'))
    } catch {
      return null
    }
  }

  const fetchCommunications = useCallback(async id => {
    const user = getUser()
    const userId = id || user?.id
    if (!userId) return
    try {
      const response = await axios.get(
        `${constants.urlLocal}communications/getCommunicationsVisibles/${userId}`
      )
      const json = response.data
      if (json.ok) {
        const unread = json.communications || []
        const read = json.readCommunications || []
        setNotifications(unread)
        setReadNotifications(read)
        setUnreadCount(unread.length)
      }
    } catch (error) {
      console.error('Error al obtener las notificaciones:', error)
    }
  }, [])

  useEffect(() => {
    fetchCommunications()
  }, [fetchCommunications])

  const updateNotifications = id => {
    fetchCommunications(id)
  }

  // Marcar UNA como leída (descartar)
  const markOneAsRead = async notifId => {
    const user = getUser()
    const userId = user?.id
    if (!userId) return
    try {
      await axios.put(
        `${constants.urlLocal}communications/markOneAsRead/${notifId}/${userId}`
      )
      // Optimistic update: mover de unread a read
      setNotifications(prev => {
        const item = prev.find(n => n._id === notifId)
        if (item) {
          setReadNotifications(r => [...r, item])
          setUnreadCount(c => Math.max(0, c - 1))
        }
        return prev.filter(n => n._id !== notifId)
      })
    } catch (error) {
      console.error('Error al marcar notificación como leída:', error)
    }
  }

  // Marcar TODAS como leídas (endpoint existente en backend)
  const markAllAsRead = async () => {
    const user = getUser()
    const userId = user?.id
    if (!userId) return
    try {
      await axios.put(
        `${constants.urlLocal}communications/markAllAsRead/${userId}`
      )
      // Mover todas las unread a read localmente (optimistic update)
      setReadNotifications(prev => [...prev, ...notifications])
      setNotifications([])
      setUnreadCount(0)
    } catch (error) {
      console.error('Error al marcar notificaciones como leídas:', error)
    }
  }

  return (
    <NotificationsContext.Provider
      value={{
        notifications,
        readNotifications,
        unreadCount,
        updateNotifications,
        markOneAsRead,
        markAllAsRead,
      }}
    >
      {children}
    </NotificationsContext.Provider>
  )
}
